// extracted by mini-css-extract-plugin
var _1 = "notificationComponentStyle-module__btn___LPKea";
var _2 = "notificationComponentStyle-module__confirmation___osSr3";
var _3 = "notificationComponentStyle-module__form-error___FBy_y";
var _4 = "notificationComponentStyle-module__form-error___FBy_y";
var _5 = "notificationComponentStyle-module__info___m2kYQ";
var _6 = "notificationComponentStyle-module__notification___hLL4t";
var _7 = "notificationComponentStyle-module__notificationsList___tfsG_";
export { _1 as "btn", _2 as "confirmation", _3 as "form-error", _4 as "formError", _5 as "info", _6 as "notification", _7 as "notificationsList" }
